<template>
  <div class="ecm__wishlist section__padding">
    <div class="ecm__wishlist-container">
      <Books v-if="!activeSkeleton" :books="wishlist" />
      <BooksSkeleton v-else />
    </div>
  </div>
</template>

<script>
import Books from '@/components/Books.vue'
import BooksSkeleton from '@/components/skeleton/Books'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Wishlist',
  components: {
    Books,
    BooksSkeleton
  },
  data () {
    return {
      activeSkeleton: true
    }
  },
  mounted () {
    this.handleFetchWishlist()
  },
  computed: {
    ...mapState({
      wishlist: state => state.wishlist.wishlist
    })
  },
  methods: {
    ...mapActions({
      fetchWishlist: 'wishlist/fetchWishlist'
    }),
    async handleFetchWishlist () {
      this.$data.activeSkeleton = true
      try {
        const resp = await this.fetchWishlist()
        if (resp.status === 'success') {
          setTimeout(() => {
            this.$data.activeSkeleton = false
          }, 1000)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style>

</style>
